import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Loader from '@components/common/Loader/newLoaderModal';
import AdvancedSurveyComp from '@components/SurveyComponent';
import {
  getSurvey,
  getSmsSurvey,
  submitSurvey,
  savePaymentNewSurvey,
} from '@reducers/survey';
import { setNotification } from '@reducers/notification';
import { getObjectValue } from '@utility/utills';

const Survey = props => {
  // Methods

  const successSurvey = isSkip => {
    window.sessionStorage.removeItem('contactDetails');
    window.sessionStorage.removeItem('selectedQuestions');
    props.handleSurveySubmit();
  };

  const failureSurvey = e => {
    props.setNotification({
      type: 'danger',
      message: e.message,
    });
  };

  const {paymentLandscapeOrientation }= props;

  const basicSurveyResult = (data, isSkip) => {
    const payload = {
      storeId: props.deviceInfo?.storeId || null,
      deviceId: props.deviceInfo?.deviceId || null,
      employeeId: props.userInfo?.id || null,
      checkHeaderId: props.seat?.id || null,
      paymentCheck: props.seat?.paymentCheck,
      survey: {
        surveyId: props.surveyData?.id,
        responses: data,
        skipped: isSkip,
        ...((props.surveyData.enableContactMe &&
          getObjectValue(() =>
            JSON.parse(sessionStorage.getItem('contactDetails'))
          )) || {
          contactEmailAddress: null,
          contactPhoneNumber: null,
          contactCountryCode: null,
        }),
      },
    };
    props
      .savePaymentNewSurvey(JSON.stringify(payload))
      .then(() => {
        successSurvey(isSkip);
      })
      .catch(failureSurvey);
  };

  // HTML CSS CODE

  return (
    <div className="col-12 p-0 w-100 h-100">
      {props.loading && <Loader />}
      {props.surveyData && (
        <AdvancedSurveyComp
          surveyData={props.surveyData}
          isHeight={props.isHeight}
          basicSurveyResult={basicSurveyResult}
          showCheckSeat={props?.showCheckSeat}
          isLandScape={paymentLandscapeOrientation}
        />
      )}
    </div>
  );
};

// REDUX Part
const mapStateToProps = state => ({
  seat: state.orders.seats,
  deviceInfo: state.oauth.deviceInformation,
  userInfo: state.oauth.loggedInUserData,
  surveyData: state.survey.surveyData,
  authResponse: state.payment.authResponse,
  isHeight: state.orders.isHeight,
  paymentLandscapeOrientation: state.payment.paymentLandscapeOrientation
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSurvey,
      getSmsSurvey,
      submitSurvey,
      setNotification,
      savePaymentNewSurvey,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Survey);
